export default function ProjectFlow() {
  const steps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Аудит текущих продаж: звонки, CRM, переписки, интервью с командой' },
    { icon: 'ri-chat-smile-2-line', title: 'Интервью', desc: 'Беседы с руководителями и менеджерами для понимания контекста и целей' },
    { icon: 'ri-file-text-line', title: 'Разработка программы', desc: 'Адаптация обучения под ваш продукт, рынок и текущий уровень команды' },
    { icon: 'ri-presentation-line', title: 'Обучение', desc: 'Интенсивный тренинг с отработкой навыков на реальных кейсах компании' },
    { icon: 'ri-gamepad-line', title: 'Практика', desc: 'Ролевые переговоры, бизнес-игры, разбор реальных встреч и звонков' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Применение навыков между модулями с последующим разбором результатов' },
    { icon: 'ri-headphone-line', title: 'Разбор переговоров', desc: 'Детальный анализ записей: что сработало, что можно улучшить' },
    { icon: 'ri-user-voice-line', title: 'Сопровождение', desc: 'Посттренинговая поддержка, аудит, корректировка стратегии' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Замер результатов', desc: 'Сравнение KPI до и после: конверсия, чек, маржа, скорость сделки' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-flow-chart"></i>
            Процесс работы
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит проект
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системный подход от диагностики до измеримого результата. Каждый этап — обязателен.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {steps.map((item, i) => (
              <div key={i} className="relative group">
                <div className="bg-gray-50 rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors h-full">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-sm">{i + 1}</span>
                    </div>
                    <div className="w-8 h-8 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600/15 transition-colors">
                      <i className={`${item.icon} text-teal-600 text-sm`}></i>
                    </div>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}